/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const CoinAcceptorStatus = {
    Unknown: 'Unknown',
    Ok: 'Ok',
    Fault: 'Fault',
    Missing: 'Missing'
} as const;
export type CoinAcceptorStatus = typeof CoinAcceptorStatus[keyof typeof CoinAcceptorStatus];

